import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import arrowUp from 'components/Layout/Header/arrow-up.svg';
import arrowDown from 'components/Layout/Header/arrow-down.svg';
import MiniAlternativeDesign from 'components/SeriesDetail/MiniDesignSelection/MiniAlternativeDesign';

const DesignSelection = ({
  isOpen,
  open,
  close,
  designOption,
  optionName,
  alternativeDesigns,
  selectedTemplateId,
  selectTemplateId,
}) => (
  <div className={styles.designExpansion}>
    <div className={styles.main}>
      <span className={styles.optionData}>
        <img
          src={designOption.iconImgUrl}
          className={styles.image}
          alt={designOption.id}
        />
        <span className={styles.optionName}>{optionName}</span>
      </span>

      {isOpen ? (
        <img
          className={styles.arrow}
          onClick={close}
          src={arrowUp}
          alt={'Up arrow'}
        />
      ) : (
        <span onClick={open}>
          <span>
            {designOption.id} - {designOption.description} $({
              designOption.upcharge
            })
          </span>
          <img className={styles.arrow} src={arrowDown} alt={'Down arrow'} />
        </span>
      )}
    </div>

    <div className={styles.designList}>
      {isOpen &&
        alternativeDesigns.map((alternativeDesign, i) => (
          <MiniAlternativeDesign
            key={i}
            design={alternativeDesign}
            selectedTemplateId={selectedTemplateId}
            selectTemplateId={selectTemplateId}
          />
        ))}
    </div>
  </div>
);

export default enhance(DesignSelection);
